"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A backbone layout which does not contain a side menu.
 * @module app/views/Layouts/NoMenu
 */
var React = require("react");
var $ = require("jquery");
var NoMenu = /** @class */ (function (_super) {
    __extends(NoMenu, _super);
    function NoMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'NoMenu';
        return _this;
    }
    NoMenu.prototype.componentDidMount = function () {
        var props = this.props;
        var refs = this.refs;
        if (props.view) {
            $(refs.wrapper).append(props.view.$el);
            props.view.render();
            props.view.delegateEvents();
        }
    };
    NoMenu.prototype.render = function () {
        return React.createElement("div", { className: "layout layout-no-menu" },
            React.createElement("div", { className: "col-md-12 main-content-page" },
                React.createElement("div", { className: "visible-xs visible-sm header-fill" }),
                React.createElement("div", { className: "row-fluid" },
                    React.createElement("div", { className: "col-md-12 main-content-wrapper", ref: "wrapper" }))));
    };
    NoMenu.identifierClass = 'layout-no-menu';
    NoMenu.layoutName = 'NoMenu';
    return NoMenu;
}(React.Component));
exports.default = NoMenu;
//# sourceMappingURL=NoMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layouts/NoMenu.js
// module id = 834
// module chunks = 1